import Splide from '@splidejs/splide';
document.addEventListener('DOMContentLoaded', function () {
    new Splide('.splide', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '2rem',
        fixedWidth: '19%',
        breakpoints: {
            1024: {
                fixedWidth: '31.5%',
            },
            640: {
                fixedWidth: '100%',
            },
        }
    }).mount();
});
